<template>
  <div>
    <PageHeader
        title="Számlaösszesítő"
        :special-back-link="true"
        :enable-back-link="true"
        @goBack="goBack"
    />
    <b-tabs v-if="documents" v-model="activeTab" style="width: 100% !important;" lazy>
      <b-tab
          v-for="document in documents"
          :key="document.id"
          :title="document.name"
      >
        <document-details :id="document.id" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import Api from "api-client";

import PageHeader from "@/components/PageHeader.vue";
import DocumentDetails from "@/views/app/document/DocumentDetails.vue";

export default {
  name: "DocumentsView",
  components: {DocumentDetails, PageHeader},
  props: {
    id: {
      type: String,
    },
  },
  data() {
    return {
      documents: [],
      activeTab: 0,
    }
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },

    getAttachedDpDocuments() {
      Api.getAttachedDpDocuments(this.id)
        .then(response => {
          this.documents = response.data;
        })
        .catch(error => {
          console.error("Error fetching attached documents:", error);
        });
    },

  },
  mounted() {
    this.getAttachedDpDocuments();
  },
}
</script>